import {
  Lock,
  Minimize2,
  Cloud,
  KeyRound,
  Ban,
  CreditCard,
  Scale,
} from "lucide-react";
import { Container } from "@/components/ui/container";
import { SectionHeading } from "@/components/ui/section-heading";
import { trustPoints } from "@/lib/content";

const icons = [Lock, Minimize2, Cloud, KeyRound, Ban, CreditCard, Scale];

export function Trust() {
  return (
    <section id="trust" aria-labelledby="trust-heading" className="py-16 sm:py-24">
      <Container>
        <SectionHeading
          titleId="trust-heading"
          eyebrow="Trust & privacy"
          title="Built with the same discipline we're asking of you."
          description="No badges, no certifications we haven't earned — just the principles the product is built on."
        />

        <ul className="mx-auto mt-12 grid max-w-4xl gap-x-8 gap-y-8 sm:grid-cols-2">
          {trustPoints.map((point, index) => {
            const Icon = icons[index % icons.length] ?? Lock;
            return (
              <li key={point.title} className="flex gap-4">
                <span
                  aria-hidden="true"
                  className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent text-accent-foreground"
                >
                  <Icon className="h-5 w-5" />
                </span>
                <div>
                  <h3 className="text-base font-semibold text-foreground">{point.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                    {point.body}
                  </p>
                </div>
              </li>
            );
          })}
        </ul>
      </Container>
    </section>
  );
}
